﻿import Box from '@mui/material/Box';
import * as React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import history from '../../shared/history';
import { Translate } from '../../shared/LanguageService';
import { useWorkaroundBodyBackground } from '../../shared/hooks/workaroundBodyBackground';

export function BrokerSystemNoAccessPage() {
    useWorkaroundBodyBackground('#e0e0e0');

    const state = history.location.state || {};
    const emailSE360 = state.sE360Email;
    const brokerSystem = state.brokerSystem;
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                paddingTop: '20px'
            }}
        >
            <Card
                sx={{
                    maxWidth: 602,
                    maxHeight: 661,
                    textAlign: 'center',
                    padding: 3,
                    boxShadow: 3
                }}
            >
                <CardContent>
                    <ErrorIcon sx={{ width: '87px', height: '87px', color: '#F44336' }} />
                    <Typography sx={{ fontSize: '24px', marginBottom: 4, marginTop: 4 }}>
                        <strong>{Translate('403-error/broker-no-access/importfailed')}</strong>
                    </Typography>

                    {emailSE360 && brokerSystem ? (
                        <Typography sx={{ marginBottom: 3, fontSize: '18px' }}>
                            {Translate('403-error/broker-no-access/loggedinwith', {
                                emailSE360: emailSE360,
                                brokerSystem: brokerSystem
                            })}
                        </Typography>
                    ) : (
                        <Typography sx={{ marginBottom: 3, fontSize: '18px' }}>
                            {Translate('403-error/broker-no-access/nouserdata')}
                        </Typography>
                    )}

                    <Typography sx={{ marginBottom: 3, fontSize: '18px' }}>
                        {Translate('403-error/broker-no-access/needtomatch')}
                    </Typography>

                    <Typography sx={{ marginBottom: 4, fontSize: '13px' }}>
                        {Translate('403-error/broker-no-access/contactsupport')}
                        <br />
                        <a href={`mailto:${Translate('403-error/broker-no-access/mail')}`}>
                            {Translate('403-error/broker-no-access/mail')}
                        </a>
                    </Typography>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={() => (window.location.href = '/')}
                    >
                        {Translate('403-error/broker-no-access/cancel')}
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
}

export default BrokerSystemNoAccessPage;
